class ProjectDetailsController {
  constructor($http, $rootScope, $stateParams, toastr) {
    'ngInject';

    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$stateParams = $stateParams;
    this.toastr = toastr;
    this.loadingProject = true;
    this.project = null;
    this.loadError = null;

    this.fetchProject()
      .then((success) => {
        this.project = success.data;
        this.loadingProject = false;
      }, (failure) => {
        this.loadError = (failure && failure.data && failure.data.message) || 'Failed to load project';
        this.loadingProject = false;
        this.toastr.error(this.loadError, 'ERROR');
      });
  }

  fetchProject(force) {
    const options = {
      withCredentials: true
    };
    if (force) {
      options.headers = { 'Cache-Control': 'no-cache' };
    }
    return this.$http.get(
      this.$rootScope.apiHost + '/api/admin/projects/' + this.$stateParams.projectId,
      options
    );
  }

  isReady() {
    return !this.loadingProject && !!(this.project && this.project.id);
  }

  isPrimeCostPlusProject() {
    return this.isReady()
      && this.project.contractClass === 'prime'
      && !!this.project.costBased;
  }

  isPrimeProject() {
    return this.isReady()
      && this.project.contractClass === 'prime'
      && !this.project.costBased;
  }

  isSubcontractProject() {
    if (!this.isReady()) {
      return false;
    }
    // Treat missing/unknown classification as subcontract so a view still renders
    return this.project.contractClass !== 'prime';
  }
}

export default ProjectDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/project-details.controller.js